<ion-segment
  color="stairs"
  mode="md"
  scrollable
  (ionChange)="onChangeSegment($event)"
  [value]="levelStairs"
  id="segment"
>
  <ng-container *ngFor="let level of NivelesPromo; let i = index">
    <ion-segment-button
      mode="md"
      [value]="level.Nivel"
      disabled
      layout="icon-bottom"
      class="segment-button-disabled"
      [id]="'segment-' + level.Nivel"
    >
      <ion-card
        mode="md"
        [color]="levelStairs === level.Nivel ? 'stairs' : 'light'"
        class="card-level"
      >
        <ion-label
          mode="md"
          [color]="levelStairs === level.Nivel ? 'white' : 'danger'"
        >
          <p
            [ngClass]="
              levelStairs === level.Nivel ? 'discount-selected' : 'discount'
            "
          >
            {{ level.Descuento | percent : "1.0-2" }}
          </p>
          <ion-text
            mode="md"
            [color]="levelStairs === level.Nivel ? 'white' : 'grayDemon'"
            class="min-max"
          >
            {{ level.Minimo }}
            {{ "Labels.a" | translate }}
            {{ level.Maximo }}
          </ion-text>
        </ion-label>
      </ion-card>

      <div
        class="triangle-down"
        [ngStyle]="{
          'border-top':
            '5px solid var(--ion-color-' +
            (levelStairs === level.Nivel ? 'stairs)' : 'white)')
        }"
      ></div>
    </ion-segment-button>
  </ng-container>
</ion-segment>
